<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
      <el-form-item label="wxPayAppId：" prop="wxPayAppId">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayAppId" placeholder="请输入"></el-input>
        <div class="mt-system-warm">说明：微信支付-商户在微信开放平台（移动应用）或公众平台（公众号\/小程序）上申请的一个唯一标识</div>
      </el-form-item>
      <el-form-item label="商户号：" prop="wxPayMerchantId">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayMerchantId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户证书序列号：" prop="wxPayMerchantSerialNumber">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayMerchantSerialNumber" placeholder="请输入"></el-input>
        <div class="mt-system-warm">说明：收货订单，在多长时间内可以申请售后</div>
      </el-form-item>
      <el-form-item label="商户APIV3密钥：" prop="wxPayV3Key">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayV3Key" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户API私钥路径：" prop="wxPayPrivateKeyPath">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayPrivateKeyPath" placeholder="" :disabled="true"></el-input>
         <upload-file :fileList="wxPayPrivateKeyPathList" :imgWhich="1" warmTxt="上传商户API私钥文件" @imgUrlBtn="imgUrlBtn"></upload-file>
      </el-form-item>
      <el-form-item label="商户API公钥路径：" prop="wxPayPublicKeyPath">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayPublicKeyPath" placeholder="" :disabled="true"></el-input>
        <upload-file :fileList="wxPayPublicKeyPathList" :imgWhich="2" warmTxt="上传商户API公钥文件" @imgUrlBtn="imgUrlBtn"></upload-file>
      </el-form-item>
      <el-form-item label="商户公钥id：" prop="wxPayPublicKeyId">
        <el-input style="width: 424px;" v-model="ruleForm.wxPayPublicKeyId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveSeleniumJourneyConfig, fetchSeleniumJourneyConfigDetail } from '@/api/journeySetting'
import UploadFile from "@/components/UploadFile";
export default {
  name: 'WxPay',
  components:{
    UploadFile
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      wxPayPublicKeyPathList:[],
      wxPayPrivateKeyPathList:[],
      ruleForm: {
        wxPayAppId:'',
        wxPayMerchantId:'',
        wxPayMerchantSerialNumber:'',
        wxPayV3Key:'',
        wxPayPrivateKeyPath:'',
        wxPayPublicKeyPath:'',
        wxPayPublicKeyId:''
      }
    }
  },
  mounted () {
    var that = this;
    fetchSeleniumJourneyConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.ruleForm = data;
        }
    })
  },
  methods: {
    imgUrlBtn(backData){
      if(backData.imgWhich == 1){
        // 商户API私钥路径
        this.ruleForm.wxPayPrivateKeyPath = backData.imgUrl;
      }else if(backData.imgWhich == 2){
        // 商户API公钥路径
        this.ruleForm.wxPayPublicKeyPath = backData.imgUrl;
      }
    },
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      that.fullscreenLoading = true
      saveSeleniumJourneyConfig(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              // that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/JourneyWxPay.vue